
import React from 'react';
import { PostAdProvider } from '../../contexts/PostAdContext';
import PostAd from './PostAd'; // Your existing UI page

const PostAdFlow = () => {
  return (
    <PostAdProvider>
      <PostAd />
    </PostAdProvider>
  );
};

export default PostAdFlow;